export const templateLanguages = {
  templateLanguage: { value: 'en-US', label: 'English' },
  templateLanguages: [
    { value: 'en-US', label: 'English' },
    { value: 'it-IT', label: 'Italiano' },
    { value: 'fr-FR', label: 'Français' },
  ],
}
